<div class="modal-header">
  <h5 class="modal-title">{{ options.title }} </h5>
</div>
<div class="modal-body">
  <div class="d-flex">
    <div class="w-100">
      <div>

        <h2 class="tw-mb-4">{{ 'lang.globals.values' | translate }}</h2>
      </div>
      <div style="height: 400px;overflow: auto;border: black 1px solid">
        <table class="table table-hover">
          <tbody>
          <tr class="cursor-pointer" *ngFor="let item of options.values" (click)="addToSelection(item)">
            <td>
              <div class="d-flex">
                <div>{{ item }}</div>
              </div>
            </td>
            <td class="tr">
              <sb-icon icon="plus" class="green"></sb-icon>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="mx-4 d-flex justify-content-center align-items-center">>>
    </div>
    <div class="w-100">
      <div class="tw-flex tw-justify-between tw-mb-2">
        <h2>{{ 'lang.globals.selectedValues' | translate }}</h2>
        <button type="button" class="btn btn-danger" (click)="clear()">
          <sb-icon icon="trash"></sb-icon>
        </button>
      </div>
      <div style="height: 400px;overflow: auto;border: black 1px solid">
        <table class="table">
          <tbody>
          <tr *ngFor="let item of selectedOptions, index as index" (click)="removeFromSelection(index)" class="cursor-pointer">
            <td>
              <div class="d-flex">
                <div><span class="font-weight-bold">{{ item }}</span></div>
              </div>
            </td>
            <td class="tr">
              <sb-icon icon="minus" class="red"></sb-icon>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</div>
<div class="modal-footer">
  <div class="d-flex justify-content-between mt-2 tw-w-full">
    <button type="button" class="btn btn-danger" (click)="cancel()">{{ 'lang.globals.cancel'|translate }}</button>
    <button type="button" class="btn btn-primary" (click)="ok()">{{ 'lang.globals.submit'|translate }}</button>
  </div>
</div>
